import * as types from './mutation-types'

export const login = ({ commit }, user) => {
  commit(types.LOGIN, user)
}

export const logout = ({ commit }) => {
  commit(types.LOGOUT)
}

export const setTagsList = ({ commit }, list) => {
  commit(types.SET_TAGS_LIST, list)
}

export const setMenuList = ({ commit }, list) => {
  commit(types.SET_MENU_LIST, list)
}

export const updateMenuList = ({ commit }) => {
  commit(types.UPDATE_MENU_LIST)
}

export const closePage = ({ commit }, name) => {
  commit(types.CLOSE_PAGE, name)
}

export const setCurrentPath = ({ commit }, pathArrray) => {
  commit(types.SET_CURRENT_PATH, pathArrray)
}

export const setCurrentPageName = ({ commit }, name) => {
  commit(types.SET_CURRENT_PAGE_NAME, name)
}

export const removeTag = ({ commit }, name) => {
  commit(types.REMOVE_TAG, name)
}

export const clearAllTags = ({ commit }) => {
  commit(types.CLEAR_ALL_TAGS)
}

export const clearOtherTags = ({ commit }, vm) => {
  commit(types.CLEAR_OTHER_TAGS, vm)
}

export const addOpenSubmenu = ({ commit }, name) => {
  commit(types.ADD_OPEN_SUBMENU, name)
}

export const clearOpenedSubmenu = ({ commit }, name) => {
  commit(types.CLEAR_OPENDED_SUBMENU, name)
}
